import React from "react";

import "./CardForm.scss";

interface IProps {
  children: React.ReactNode;
  center?: boolean;
}

interface IPropsInner {
    children: React.ReactNode;
    onSubmit?: (data: React.FormEvent<HTMLFormElement>) => void;
}

const CardForm = ({ children, center }: IProps) => {
  return (
    <div className={`card-form ${center ? "text-center" : ""}`}>
        {children}
    </div>
  );
};

export const CardFormInner = ({children, onSubmit}: IPropsInner) => {

  return (
      <form className={"card-form-inner"} onSubmit={onSubmit}>
        {children}
      </form>
  )
}

export const CardFormBottom = ({children}: IProps) => {

  return (
      <div className={"card-form-bottom"}>
        {children}
      </div>
  )
}

export const CardFormOutside = ({children}: IProps) => {
    return (
        <div className={"card-form-outside"}>
            {children}
        </div>
    )
}

export default CardForm;
